import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import GetBasicInfo from './getBasicInfo';
import Finalize from './finalize';

class RegisterForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      fields: {
        email: '',
        firstname: '',
        lastname: '',
        name: '',
        company_name: '',
        industry: '',
        country: '',
        password: '',
        telephone: '',
        role: '',
        pilot: ''
      },
      showPassword: false,
      test: "test"
    };

    this.showPassword = this.showPassword.bind(this);
  }

  handleChange(e) {
    const { name, value } = e.target
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: value
      }
    })
  }

  changeSelectValue(name, value) {
    this.setState({
      fields: {
        ...this.state.fields,
        [name]: value
      }
    })
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  moveToNext() {
    this.setState({ step: this.state.step + 1 });
  }

  goBack() {
    this.setState({ step: this.state.step - 1 });
  }

  onSubmit() {
    this.props.history.push('/confirmation');
    //window.location.replace = "https://app/postured.io/login"
  }

  render() {
    const { step } = this.state;

    return (
      <React.Fragment>
        {
          step === 0 ?
          <GetBasicInfo
                 handleChange={this.handleChange.bind(this)}
                 changeSelect={this.changeSelectValue.bind(this)}
                 next={this.moveToNext.bind(this)}
                 back={this.goBack.bind(this)}
                 fields={this.state.fields}
               />
          : step === 1 ?
          <Finalize
          handleChange={this.handleChange.bind(this)}
          changeSelect={this.changeSelectValue.bind(this)}
          next={this.moveToNext.bind(this)}
          back={this.goBack.bind(this)}
          fields={this.state.fields}
        />
        : null

          // step === 0 ?
          //   <GetEmail value={this.state.fields.email} handleChange={this.handleChange.bind(this)} next={this.moveToNext.bind(this)} />
          //   : step === 1 ?
          //     <GetBasicInfo
          //       handleChange={this.handleChange.bind(this)}
          //       changeSelect={this.changeSelectValue.bind(this)}
          //       next={this.moveToNext.bind(this)}
          //       back={this.goBack.bind(this)}
          //       fields={this.state.fields}
          //     />
          //     : step === 2 ?
          //       <Finalize
          //         handleChange={this.handleChange.bind(this)}
          //         changeSelect={this.changeSelectValue.bind(this)}
          //         next={this.moveToNext.bind(this)}
          //         back={this.goBack.bind(this)}
          //         fields={this.state.fields}
          //       />
          //       : null
        }
      </React.Fragment>
    )
  }
}

export default withRouter(RegisterForm);



// WEBPACK FOOTER //
// ./src/pages/account/register/components/RegisterForm.js